module.exports = __webpack_public_path__ + "images/store_case_study/wwatchsalon-pic1_ad581135a7024689bb568d657a06873f.jpg";